// import package and components

import React, { useEffect, useReducer, useState } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
// import ScrollRestoration from 'react-scroll-restoration'
import "./App.css";
import Context from "./Context";
import UserAccess from "./UserAccess";
import TokenManager from "./utils/TokenManager";
import AboutUS from "./views/AboutUS";
import AudioDetails from "./views/AudioDetails";
import Audios from "./views/Audios";
import Booking from "./views/Booking/Booking";
import { statusFailure } from "./views/Constant";
import Contest from "./views/Contest";
import ContestResult from "./views/ContestResult";
import CookiesPolicy from "./views/CookiesPolicy";
import EventPurchasePage from "./views/EventPurchase";
import FAQ from "./views/FAQ";
import Forgot from "./views/Forgot";
import EmailForgotPassword from "./views/EmailForgotPassword";
import EmailRegister from "./views/EmailRegister";
import Home from "./views/Home";
import Login from "./views/Login";
import Movies from "./views/Movies";
import MoviesDetails from "./views/MoviesDetails";
import OurTeam from "./views/OurTeam";
import OurVision from "./views/OurVision";
import Package from "./views/Package/Package";
import PoemCreate from "./views/Poem/PoemCreate";
import PoemDetails from "./views/PoemDetails";
import Poems from "./views/Poems";
import PrivacyPolicy from "./views/PrivacyPolicy";
import Profile from "./views/Profile";
import Register from "./views/Register";
import Stories from "./views/Stories";
import contestStories from "./views/contestStories";
import contestPoetries from "./views/ContestPoetries";
import Poetries from "./views/poetries";
import StoryCreate from "./views/Story/StoryCreate";
import StroyDetailsNew from "./views/Story/StoryDetailsNew";
import StoryWrite from "./views/Write/WriteStory";
import TermCondition from "./views/TermCondition";
import Thumbnail from "./views/Thumbnail";
import UpdatePassword from "./views/UpdatePassword";
import EmailSetPassword from "./views/EmailSetPassword";
import UpdateUserProfile from "./views/UpdateUserProfile";
import UserType from "./views/UserType";
import VideoDetails from "./views/VideoDetails";
import Videos from "./views/Videos";
import WhatWeDo from "./views/WhatWeDo";
import WhoWeAre from "./views/WhoWeAre";
// import Payment from "./views/payment";
import { getProfileDetails } from "./views/utilities/ApiCalls";

import OpenMic from "./views/OpenMic";
import OpenMics from "./views/OpenMics";
import PoemWrite from "./views/Write/WritePoem";
import { UserProfile } from "./views/userProfile";
import ChatWrapper from "./views/Chat/ChatWrapper";
import PublicPortfolio from "./views/PublicPortfolio";
import Message from "./views/Chat/Message";
import FollowerFollowingList from "./views/FollowerFollowingList";
import { UserByName } from "./views/UserByName";
import Explore from "./views/Explore";
import Events from "./views/Events";
import Create from "./views/Create";
import { Setting } from "./views/Setting";
import { EditProfile } from "./views/EditProfile";
import EditPortfolioPage from "./views/EditPortfolioPage";
import Languate, { Language } from "./views/Language";
import NotificationPage from "./views/Notification";
import OpemMicPage from "./views/OpemMicPage";
import MyProfileDetails from "./views/MyProfileDetails";
import SearchBar from "./views/SearchBar";
import { HelmetProvider } from "react-helmet-async";
import OpenMicOfflineParticipantForm from "./views/OpenMicOfflineParticipantForm";

import ReactGA from "react-ga4";
import DeleteAccount from "./views/DeleteAccount";
import EventForm from "./views/EventForm";
import ZoomHome from "./views/Zoom/Meet";
import CreateMeet from "./views/Zoom/CreateMeet";
import EventsMeet from "./views/Zoom/EventsMeet";
import AntiMatterPage from "./views/Zoom/AntiMatterPage";
import LopResult from "./Componets/LafxOfParadiseResult";
import SimpleEventSubEvent from "./views/SimpleEventSubEvent";
import SimpleEvent from "./views/SimpleEvent";
import SpotlightDetails from "./views/SpotlightDetails";
import SecuredRoute from "./SecuredRoute";
import IndiverseFinalists from "../src/views/IndiverseFinalists";
import TestSecureMessaging from "./views/secure-chat/TestSecureMessaging";
import SecureChatLayout from "./views/secure-chat/SecureChatLayout";
import IndiverseFinale from "./views/IndiverseFinale";

/* End */

const TRACKING_ID = "G-ZVBXCJGRTP";

ReactGA.initialize(TRACKING_ID, { debug_mode: true });

function reducer(state, { payload, type }) {
  switch (type) {
    case "login":
      localStorage.setItem("loginDetails", payload);
      return {
        ...state,
        token: payload,
      };
    case "logout":
      // TokenManager.clearAllTokens() is called in NewAuthNav.js
      // We don't need to manually remove loginDetails here anymore
      // as TokenManager handles both access and refresh tokens
      // console.log("[WEB1] REDUCER: Logout dispatched, clearing state");

      return {
        ...state,
        token: null,
        user: {},
        isPrime: false,
        isAdult: false,
      };
    case "user":
      // Extract isAdult from user data if available
      const userIsAdult = payload?.data?.isAdult ?? false;
      return {
        ...state,
        user: payload,
        isAdult: userIsAdult,
      };
    case "isPrime":
      return {
        ...state,
        isPrime: !!payload,
      };
    case "setIsAdult":
      return {
        ...state,
        isAdult: !!payload,
      };
    default:
      return state;
  }
}

export default function App() {
  let token = localStorage.getItem("loginDetails");
  // console.log("token is", token);
  const [state, dispatch] = useReducer(reducer, {
    token,
    user: {},
    isPrime: false,
    isAdult: false, // Global state for adult mode
  });
  const [tokenCheckComplete, setTokenCheckComplete] = useState(false);

  // Token check and refresh on app load
  useEffect(() => {
    const checkAndRefreshToken = async () => {
      // console.log("[WEB1] APP LOAD: Starting token check and refresh");

      try {
        // Check if we have tokens in the new format
        const accessToken = TokenManager.getAccessToken();
        const refreshToken = TokenManager.getRefreshToken();

        if (accessToken && refreshToken) {
          // console.log(
          //   "[WEB1] APP LOAD: Found tokens in new format, checking validity"
          // );
          const isValid = await TokenManager.checkAndRefreshToken();
          if (!isValid) {
            // console.log(
            //   "[WEB1] APP LOAD: Token validation failed, user will be redirected"
            // );
            setTokenCheckComplete(true);
            return;
          }

          // Update state with refreshed token if refresh happened
          const updatedToken = TokenManager.getAccessToken();
          if (updatedToken && updatedToken !== token) {
            // console.log("[WEB1] APP LOAD: Token refreshed, updating state");
            dispatch({ type: "login", payload: updatedToken });
          }
        } else if (token) {
          // Migrate old token format to new format
          // console.log(
          //   "[WEB1] APP LOAD: Found old token format, checking validity"
          // );

          // Check if old token is expired
          if (TokenManager.isTokenExpired(token)) {
            // console.log(
            //   "[WEB1] APP LOAD: Old token format is expired, clearing and redirecting to login"
            // );
            TokenManager.clearAllTokens();
            dispatch({ type: "logout" });
            setTokenCheckComplete(true);
            return;
          }

          // Old token is still valid, continue with existing flow
          // console.log(
          //   "[WEB1] APP LOAD: Old token format detected and valid, continuing with existing flow"
          // );
        }

        // console.log("[WEB1] APP LOAD: Token check completed");
      } catch (error) {
        // console.error("[WEB1] APP LOAD: Error during token check:", error);
        // If token check fails, clear tokens and redirect to login
        TokenManager.clearAllTokens();
        dispatch({ type: "logout" });
      } finally {
        setTokenCheckComplete(true);
      }
    };

    checkAndRefreshToken();
  }, []);

  useEffect(() => {
    // Only fetch profile after token check is complete to avoid race conditions
    if (!tokenCheckComplete) return;

    const fetchProfile = async () => {
      const currentToken = TokenManager.getAccessToken() || state.token;
      if (!currentToken) {
        // console.log("[WEB1] APP LOAD: No token available for profile fetch");
        return;
      }

      try {
        // Double-check token validity before making API call
        const accessToken = TokenManager.getAccessToken();
        if (accessToken) {
          // New token format - use TokenManager to check and refresh
          const isValid = await TokenManager.checkAndRefreshToken();
          if (!isValid) {
            // console.log("[WEB1] APP LOAD: Token invalid before profile fetch");
            return;
          }

          // Update state if token was refreshed
          const updatedToken = TokenManager.getAccessToken();
          if (updatedToken && updatedToken !== state.token) {
            dispatch({ type: "login", payload: updatedToken });
          }
        } else if (state.token) {
          // Old token format - check if expired
          if (TokenManager.isTokenExpired(state.token)) {
            // console.log(
            //   "[WEB1] APP LOAD: Old token format is expired, cannot fetch profile"
            // );
            TokenManager.clearAllTokens();
            dispatch({ type: "logout" });
            return;
          }
          // Old token is valid, proceed with API call
        }

        const response = await getProfileDetails();
        // console.log("response", response.data);
        if (response.status !== statusFailure) {
          dispatch({ type: "user", payload: response.data });
        } else {
          dispatch({ type: "user", payload: {} });
          // console.log(response.message);
        }
      } catch (error) {
        // console.error("[WEB1] APP LOAD: Error fetching profile:", error);
        // If API call fails due to expired token, try to refresh once more
        if (error.response?.status === 401 || error.response?.status === 403) {
          const accessToken = TokenManager.getAccessToken();
          const refreshToken = TokenManager.getRefreshToken();

          // Only try to refresh if we have both tokens (new format)
          if (accessToken && refreshToken) {
            const refreshed = await TokenManager.checkAndRefreshToken();
            if (refreshed) {
              // Retry profile fetch after successful refresh
              try {
                const retryResponse = await getProfileDetails();
                if (retryResponse.status !== statusFailure) {
                  dispatch({ type: "user", payload: retryResponse.data });
                }
              } catch (retryError) {
                // console.error(
                //   "[WEB1] APP LOAD: Profile fetch retry failed:",
                //   retryError
                // );
              }
            }
          } else {
            // Old token format - cannot refresh, clear and logout
            // console.log(
            //   "[WEB1] APP LOAD: Old token format expired, cannot refresh"
            // );
            TokenManager.clearAllTokens();
            dispatch({ type: "logout" });
          }
        }
      }
    };

    fetchProfile();
  }, [tokenCheckComplete, state.token]);

  useEffect(() => {
    if (state.isPrime) {
      dispatch({ type: "isPrime", payload: true });
    } else {
      dispatch({ type: "isPrime", payload: false });
    }
  }, [state.user]);

  return (
    <HelmetProvider>
      <Context.Provider value={{ state, dispatch }}>
        <Router>
          {/* <ScrollRestoration /> */}
          <Switch>
            <Route
              exact
              strict
              path="/test-secure-messaging"
              component={TestSecureMessaging}
            />
            <UserAccess
              exact
              strict
              path="/secure-chat"
              component={SecureChatLayout}
            />
            <Route exact strict path="/" component={Home} />
            <Route exact strict path="/about-us" component={AboutUS} />
            <Route
              exact
              strict
              path="/delete-account"
              component={DeleteAccount}
            />
            <Route exact strict path="/who-we-are" component={WhoWeAre} />
            <Route exact strict path="/what-we-do" component={WhatWeDo} />
            <Route exact strict path="/our-vision" component={OurVision} />
            <Route exact strict path="/our-partner" component={OurTeam} />
            <Route exact strict path="/faqs" component={FAQ} />
            <Route
              exact
              strict
              path="/Lafzofparadise-contestResult"
              component={LopResult}
            />
            <Route
              exact
              strict
              path="/Indiverse-finalists"
              component={IndiverseFinalists}
            />
            <Route
              exact
              strict
              path="/Indiverse-finale"
              component={IndiverseFinale}
            />
            <Route
              exact
              strict
              path="/Storytent-Meeting"
              component={ZoomHome}
            />
            <Route exact strict path="/Create-Meeting" component={CreateMeet} />
            <Route
              exact
              strict
              path="/events/antimatter"
              component={AntiMatterPage}
            />
            <Route
              exact
              strict
              path="/contest-story"
              component={StoryWrite}
            />
            <Route exact strict path="/contest-poem" component={PoemWrite} />

            <UserAccess
              exact
              strict
              path="/user/searchUsersByName"
              component={UserByName}
            />

            <Route exact strict path="/register" component={Register} />
            <Route
              exact
              strict
              path="/register-email"
              component={EmailRegister}
            />
            <Route exact strict path="/login" component={Login} />
            <Route exact strict path="/forgot" component={Forgot} />
            <Route
              exact
              strict
              path="/forgot-password"
              component={EmailForgotPassword}
            />
            <Route
              exact
              strict
              path="/set-password"
              component={EmailSetPassword}
            />
            <Route exact strict path="/" component={Forgot} />
            <UserAccess exact strict path="/plans" component={Package} />
            <UserAccess
              exact
              strict
              path="/TicketBooking/:id"
              component={Booking}
            />

            <UserAccess
              exact
              strict
              path="/userFollowers/:userId"
              component={FollowerFollowingList}
            />

            <Route
              exact
              strict
              path="/term-condition"
              component={TermCondition}
            />
            <Route
              exact
              strict
              path="/terms-and-conditions"
              component={TermCondition}
            />
            <Route
              exact
              strict
              path="/terms-condition"
              component={TermCondition}
            />
            <Route
              exact
              strict
              path="/terms"
              component={TermCondition}
            />
            <UserAccess exact strict path="/stories" component={Stories} />
            <UserAccess
              exact
              strict
              path="/contestStories/:contestId"
              component={contestStories}
            />
            <UserAccess
              exact
              strict
              path="/EventForm/:EventId"
              component={EventForm}
            />
            <UserAccess
              exact
              strict
              path="/contestPoetries/:contestId"
              component={contestPoetries}
            />
            <UserAccess exact strict path="/poetries" component={Poetries} />
            <UserAccess
              exact
              strict
              path="/story-details/:id"
              component={StroyDetailsNew}
            />
            <Route exact strict path="/videos" component={Videos} />
            <Route exact strict path="/movies" component={Movies} />
            <Route exact strict path="/audios" component={Audios} />
            <UserAccess
              exact
              strict
              path="/story-create"
              component={StoryWrite}
            />

            <Route exact strict path="/videos" component={Videos} />
            <Route exact strict path="/movies" component={Movies} />
            <Route exact strict path="/audios" component={Audios} />
            <UserAccess exact strict path="/create" component={Create} />

            <UserAccess exact strict path="/chat" component={ChatWrapper} />

            <UserAccess
              exact
              strict
              path="/setting/language"
              component={Language}
            />

            <UserAccess
              exact
              strict
              path="/notification"
              component={NotificationPage}
            />

            <SecuredRoute
              exact
              strict
              path="/openmic/:id"
              component={OpemMicPage}
            />

            <UserAccess
              exact
              strict
              path="/setting/edit"
              component={EditProfile}
            />

            <UserAccess
              exact
              strict
              path="/setting/portfolio"
              component={EditPortfolioPage}
            />

            <UserAccess exact strict path="/settings" component={Setting} />

            <UserAccess
              exact
              strict
              path="/chat/:userId/:id"
              component={Message}
            />
            <UserAccess
              exact
              strict
              path="/update-story"
              component={StoryCreate}
            />
            <Route exact strict path="/poems" component={Poems} />
            <Route
              exact
              strict
              path="/poem-details/:id"
              component={PoemDetails}
            />
            <UserAccess
              exact
              strict
              path="/poem-create"
              component={PoemWrite}
            />
            <UserAccess
              exact
              strict
              path="/update-poem"
              component={PoemWrite}
            />

            <UserAccess exact strict path="/user-type" component={UserType} />
            <Route
              exact
              strict
              path="/update-password"
              component={UpdatePassword}
            />
            <UserAccess
              exact
              strict
              path="/profile/:userId"
              component={Profile}
            />
            <UserAccess exact strict path="/explore" component={Explore} />
            <UserAccess exact strict path="/events" component={Events} />
            <UserAccess
              exact
              strict
              path="/userprofile/:userId"
              component={UserProfile}
            />
            <Route
              exact
              strict
              path="/portfolio/:userId"
              component={PublicPortfolio}
            />
            <UserAccess exact strict path="/location" component={Location} />
            <UserAccess
              exact
              strict
              path="/update-profile"
              component={UpdateUserProfile}
            />

            <Route
              exact
              strict
              path="/privacy-policy"
              component={PrivacyPolicy}
            />

            <Route exact strict path="/search" component={SearchBar} />

            <Route
              exact
              strict
              path="/cookies-policy"
              component={CookiesPolicy}
            />
            <UserAccess
              exact
              strict
              path="/video-details/:id"
              component={VideoDetails}
            />
            <UserAccess
              exact
              strict
              path="/movies-details/:id"
              component={MoviesDetails}
            />
            <UserAccess
              exact
              strict
              path="/audio-details/:id"
              component={AudioDetails}
            />
            <UserAccess
              exact
              strict
              path="/contest/:type"
              component={Contest}
            />
            <UserAccess
              exact
              strict
              path="/select-thumbnail/:type"
              component={Thumbnail}
            />
            <UserAccess
              exact
              strict
              path="/contest-result/:id/:type"
              component={ContestResult}
            />
            {/* <Route exact strict path="/online-payment" component={Payment} /> */}
            <Route
              exact
              strict
              path="/event-payment"
              component={EventPurchasePage}
            />
            <Route exact strict path="/package" component={Package} />
            <Route exact strict path="/booking" component={Booking} />
            <Route exact strict path="/profile" component={MyProfileDetails} />
            {/* <Route exact strict path="/story-write" component={StoryWrite} /> */}
            {/* <Route
            exact
            strict
            path="/story-detailnew"
            component={StroyDetailsNew}
          /> */}

            <SecuredRoute
              exact
              strict
              path="/open-mic/:id"
              component={OpenMic}
            />
            <SecuredRoute exact strict path="/open-mics" component={OpenMics} />
            <Route
              exact
              strict
              path="/simple-event/:id"
              component={SimpleEvent}
            />
            <Route
              exact
              strict
              path="/simple-sub-event/:id"
              component={SimpleEventSubEvent}
            />
            <Route
              exact
              strict
              path="/spotlights"
              component={SpotlightDetails}
            />

            <Route
              path="/OpenMicOfflineParticipantForm"
              component={OpenMicOfflineParticipantForm}
            />

            {/* <Route path="*" component={PageNotFound} /> */}
          </Switch>
        </Router>
      </Context.Provider>
    </HelmetProvider>
  );
}
